import { useNavigate, useRouter } from '@tanstack/react-router';
import { ReceiptPage } from '../../features/stock/ui/ReceiptPage.js';
import { StockSearchPage } from '../../features/stock/ui/StockSearchPage.js';
import { ScanLine } from 'lucide-react';
import { Button } from '@eombor/ui';
import { t } from '../../shared/i18n/index.js';
import { openScanner } from '../../shared/scanner/scanner-dialog.store.js';
import { BackButton } from '../../shared/ui/BackButton.js';
import { usePermission } from '../../features/auth/model/usePermission.js';
import { GLOBAL_STOCK_PATH, LIST_PATH, RECEIPT_PATH } from './warehouses.js';

/**
 * Marshrut bilan sahifa orasidagi yupqa qatlam — `warehouses.tsx` dagi naqsh:
 * sahifalar routerni bilmaydi, ular `onDone` kabi chaqiruv oladi.
 *
 * Manzillar `warehouses.tsx` dan keladi: mahsulotlar endi "Ombor" bo'limining
 * ichida turadi va yo'l ikki faylda ayri ketmasligi kerak.
 */

export const StockSearchRoute = () => {
  const navigate = useNavigate();
  const router = useRouter();
  const { canAnywhere } = usePermission();
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        {/* Omborlar ro'yxatiga qaytish. Ro'yxatni ko'ra olmaydigan xodimga
            chizilmaydi: u yerdan baribir shu sahifaga qaytarib yuboriladi.
            Tarixda orqa qadam bo'lmasa (to'g'ridan-to'g'ri havola) —
            ro'yxatning o'ziga o'tiladi. */}
        {canAnywhere('warehouse.read') ? (
          <BackButton
            onClick={() => {
              if (router.history.canGoBack()) router.history.back();
              else void navigate({ to: LIST_PATH });
            }}
          >
            {t('warehouse.backToList')}
          </BackButton>
        ) : (
          <span aria-hidden />
        )}
        {/*
          SKANER TUGMASI — imkoniyatni KO'RSATADI. Qurilmaning o'zi baribir
          butun tizim bo'ylab ishlaydi va oynani o'zi ochadi, lekin ko'rinmagan
          imkoniyat — yo'q imkoniyat: yangi skladchi skaner borligini bilishi
          kerak. Tugma esa skanersiz kunda ham yo'l qoldiradi.
        */}
        <Button variant="secondary" onClick={() => openScanner()}>
          <ScanLine size={16} aria-hidden />
          {t('warehouse.scanOpen')}
        </Button>
      </div>
      <StockSearchPage
        onNewReceipt={() => void navigate({ to: RECEIPT_PATH })}
        /* Savat talabnoma ekranida turadi — bu yerda faqat havola.
           `CREATE_PATH` yozilgan yo'llar ro'yxatida, shuning uchun
           oddiy satr sifatida beriladi (`requisitions.tsx` dagi kabi). */
        onNewRequisition={() => void navigate({ to: '/requisitions/new' })}
      />
    </div>
  );
};

export const ReceiptRoute = () => {
  const navigate = useNavigate();
  const router = useRouter();
  return (
    <ReceiptPage
      onDone={() => void navigate({ to: GLOBAL_STOCK_PATH })}
      /* Tarixda BITTA qadam orqaga — yangi yozuv qo'shilmaydi. Sahifa
         to'g'ridan-to'g'ri havola bilan ochilgan bo'lsa orqada ilovaning
         o'z sahifasi yo'q: shunda Omborxonaga o'tiladi. */
      onBack={() => {
        if (router.history.canGoBack()) router.history.back();
        else void navigate({ to: GLOBAL_STOCK_PATH });
      }}
    />
  );
};
